import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-lg border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_b286a459-1ebd-49cc-9e3f-46880bb89d86/artifacts/1zkgq9wl_Tappollo_icon.png" 
              alt="Fundability.ai" 
              className="w-10 h-10 rounded-lg object-contain"
            />
            <div className="hidden sm:flex flex-col">
              <span className="text-white font-semibold text-xl leading-tight">Fundability.ai</span>
              <span className="text-white/50 text-xs">by Tappollo</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#work" className="text-white/70 hover:text-white transition-colors text-sm">
              Work
            </a>
            <a href="#pricing" className="text-white/70 hover:text-white transition-colors text-sm">
              Pricing
            </a>
            <a href="#faq" className="text-white/70 hover:text-white transition-colors text-sm">
              FAQ
            </a>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <Button
              className="bg-white text-black hover:bg-white/90 rounded-full px-6 font-medium"
              onClick={() => window.open('https://calendly.com/superboonie', '_blank')}
            >
              Setup a Call
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/10 pt-4">
            <div className="flex flex-col gap-4">
              <a href="#work" className="text-white/70 hover:text-white transition-colors">
                Work
              </a>
              <a href="#pricing" className="text-white/70 hover:text-white transition-colors">
                Pricing
              </a>
              <a href="#faq" className="text-white/70 hover:text-white transition-colors">
                FAQ
              </a>
              <Button
                className="bg-white text-black hover:bg-white/90 rounded-full px-6 font-medium w-fit"
                onClick={() => window.open('https://calendly.com/superboonie', '_blank')}
              >
                Setup a Call
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;